import { styled } from '@mui/material/styles';
import { slideLayout, hideScrollBar } from 'mui/components/sharedStyles/layoutStyles';

export const BottomCaptionCardsContainer = styled('div')(
  ({ theme }) => `

    ${slideLayout};
    ${hideScrollBar};

    > a, > div {
      height: 184px;
      min-width: 145px;
      width: 145px;
  
      :first-child {
        margin-left: ${theme.DS_spacing(['md'])};
      }
      :last-child {
        margin-right: ${theme.DS_spacing(['md'])};
      }
    }
    
    ${theme.breakpoints.up('md')} {
   
      gap: ${theme.DS_spacing(['sm'])};

      > a, > div {
       height: 274px;
       min-width: 202px;
       width: 202px;
     
        :first-child {
          margin-left: ${theme.DS_spacing(['lgx'])};
        }
        :last-child {
          margin-right: ${theme.DS_spacing(['lgx'])};
        }
      }
    }
    
    ${theme.breakpoints.up('lg')} {
      margin-bottom: ${theme.DS_spacing(['sm'])};
      padding-left: 120px;
    
      > a, > div {
       width: 238.4px;
       min-width: 238.4px;
       height: 320px;
        :first-child {
          margin-left: 0;
        }
        :last-child {
          margin-right: 0;
        }
      }
    }
  `,
);
